import {Card, Col, Empty, Row} from "antd";
import {useEffect, useState} from "react";
import {Button, Loading} from "../../../components";
import {useParams} from "react-router-dom";
import {apiError, handleRequest, renderDate, strToTime} from "../../../utils";
import {promotionApi} from "../../../api";
import DOMPurify from "dompurify";
import ActionBar from "../../../layout/ActionBar";
import {Controller, useForm} from "react-hook-form";
import {DateField, EditorField, GroupCheckBoxField, InputField, SelectField} from "../../../components/Forms";
import * as Yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {globalNavigate} from "../../../routes/GlobalHistory";

function PromotionEdit()
{
    const {id} = useParams();

    const [loading, setLoading] = useState(true);

    const [errorLoad, setErrorLoad] = useState(false);

    const [promotion, setPromotion] = useState({});

    const typeOptions = [
        {value: 'all', label: "Nhiều loại"},
        {value: 'marketing', label: "Marketing"},
        {value: 'website', label: "Website"},
        {value: 'host', label: "Host"},
        {value: 'ssl', label: "SSL"},
        {value: 'email', label: "Email server"},
    ]

    const showOptions = [
        {value: 1, label: "Kinh doanh Sikido"},
        {value: 2, label: "Kinh doanh D&H"},
        {value: 3, label: "Kinh doanh Fast Digital"},
        {value: 4, label: "Khách hàng"},
    ]

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Bạn chưa điền tên chương trình'),
        content: Yup.string().required('Bạn chưa điền chi tiết chương trình'),
        timeStart: Yup.string().required('Bạn chưa chọn ngày bắt đầu chạy chương trình'),
        timeEnd: Yup.string().required('Bạn chưa chọn ngày kết thúc chương trình'),
        type: Yup.string().required('Bạn chưa chọn loại khuyến mãi'),
        show: Yup.array().required('Bạn chưa chọn đối tượng hiển thị khuyến mãi'),
    })

    const initialValues = {
        name: '',
        content: '',
        timeStart: new Date(),
        timeEnd: new Date(),
        type: 'all',
        show: [],
    }

    const { control, handleSubmit, formState: { isSubmitting, errors }, reset, setValue } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validationSchema)
    });

    const eventHandlers = {
        load: async () => {

            let [error, response] = await handleRequest(promotionApi.detail({
                id: id
            }));

            let message = apiError(`Load chương trình thất bại`, error, response);

            if (!message)
            {
                initialValues.name = response.data.name;
                initialValues.content = response.data.content;
                initialValues.type = response.data.type;
                initialValues.show = response.data.show;
                initialValues.timeStart = response.data.timeStart*1000;
                initialValues.timeEnd = response.data.timeEnd*1000;
                reset(initialValues);
                setPromotion(response.data);
                setErrorLoad(false)
            }
            else
            {
                setErrorLoad(true);
            }

            setLoading(false);
        },
        submit: async (data) => {
            const formData = new FormData();
            formData.append('id', promotion.id);
            formData.append('name', data.name);
            formData.append('content', data.content);
            formData.append('type', data.type);
            data.show.forEach(value => {
                formData.append('show[]', value);
            });
            formData.append('timeStart', strToTime(data.timeStart));
            formData.append('timeEnd', strToTime(data.timeEnd));
            if (data.file) formData.append('file', data.file);

            let [error, response] = await handleRequest(promotionApi.update(promotion.id, formData));

            let message = apiError(`Cập nhật chương trình khuyến mãi thất bại`, error, response);

            if (!message) {
                globalNavigate("/promotion");
            }
        },
    }

    useEffect(() => {
        eventHandlers.load().then()
    }, [id])

    if(loading) {
        return (
            <div className="container">
                <Loading/>
            </div>
        )
    }

    if(errorLoad) {
        return (
            <div className="container">
                <Empty description={<span>Không có chương trình</span>}><Button to={'/promotion'}>Quay lại danh sách chương trình khuyến mãi</Button></Empty>
            </div>
        )
    }

    return (
        <>
            <ActionBar title={'Cập nhật chương trình khuyến mãi'}>
            </ActionBar>
            <div className="container">
                <div className="content pd-3" style={{overflow: 'auto'}}>
                    <form className="form mt-3 mb-3" onSubmit={handleSubmit(eventHandlers.submit)}>
                        {isSubmitting && <Loading/>}
                        <Row gutter={10}>
                            <Col className="gutter-row" span={12}>
                                <Controller control={control} name="name" render={({ field }) => (
                                    <InputField label="Tên chương trình" errors={errors} {...field}/>
                                )}/>
                                <Controller control={control} name="content" render={({ field }) => (
                                    <EditorField label="Nội dung chương trình" errors={errors} {...field}/>
                                )}/>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <p className="heading">Thông tin</p>
                                <Row gutter={10}>
                                    <Col className="gutter-row" span={8}>
                                        <Controller control={control} name="type" render={({field}) => (
                                            <SelectField label="Loại khuyến mãi" options={typeOptions} errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                    <Col className="gutter-row" span={8}>
                                        <Controller control={control} name="timeStart" render={({field}) => (
                                            <DateField label="Ngày bắt đầu chạy" errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                    <Col className="gutter-row" span={8}>
                                        <Controller control={control} name="timeEnd" render={({ field }) => (
                                            <DateField label="Ngày kết thúc" errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                </Row>
                                <Row gutter={10}>
                                    <Col className="gutter-row" span={24}>
                                        <Controller control={control} name="show" render={({field}) => (
                                            <GroupCheckBoxField label="Chỉ hiển thị cho" options={showOptions} errors={errors} {...field}/>
                                        )}/>
                                    </Col>
                                </Row>
                                <Controller control={control} name="file" render={({field}) => (
                                    <InputField
                                        label="Ảnh đại diện"
                                        type="file"
                                        errors={errors}
                                        onChange={(e) => {
                                            field.onChange(e.target.files[0]); // chỉ lấy 1 file
                                        }}
                                    />
                                )}/>
                            </Col>
                        </Row>
                        <div className="form-group">
                            <Button primary type="submit">Cập nhật chương trình</Button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}

export default PromotionEdit;